var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"m-icon",attrs:{"viewBox":_vm.icon.viewBox},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('use',{ref:"useElement",attrs:{"href":_vm.iconUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }